import { createReducer, createTypes } from 'reduxsauce';

export const operacionalTypes = createTypes(
  `
        SET_ENERGY
        SET_REALTIME
        SET_HISTORIC
        SET_THING_DATA
        SET_OPERATIONAL_STATUS
    `,
  { prefix: 'OPERACIONAL/' }
);

const INITIAL_STATE = {
  energy: null,
  realtimeData: null,
  values: {},
  operationalStatus: [],
};

const energy = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    energy: action.data,
  };
};

const realtimeData = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    realtimeData: action.data,
  };
};

const historic = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    historic: {
      ...state.historic,
      [action.type]: action.data,
    },
  };
};

const setValues = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    values: {
      ...action.values,
    },
  };
};

const setOperationalStatus = (state = INITIAL_STATE, action) => {
  return { ...state, operationalStatus: action.data };
};

export default createReducer(INITIAL_STATE, {
  [operacionalTypes.SET_ENERGY]: energy,
  [operacionalTypes.SET_REALTIME]: realtimeData,
  [operacionalTypes.SET_HISTORIC]: historic,
  [operacionalTypes.SET_THING_DATA]: setValues,
  [operacionalTypes.SET_OPERATIONAL_STATUS]: setOperationalStatus,
});
